<div>
  <div class="avatar" [ngClass]="type" [ngStyle]="{ 'background-image': 'url(' + data.avatar + ')'}" *ngIf="data.avatar" ></div>
  <div *ngIf="!data.avatar" [ngClass]="type" class="avatar horizontal layout center center-justified" [ngStyle]="{ 'background-color': data.color }"><span *ngIf="data.fullName">{{data.fullName[0]}}</span></div>
</div>